import React, { useState, useEffect, useCallback } from 'react';
import api from '../../utils/api';
import PedidoAcciones from '../ui/PedidoAcciones';
import Presupuestos from '../../pages/Presupuestos';
import { useSession } from '../../contexts/SessionContext';

function fmtFecha(f) {
  if (!f) return '—';
  return new Date(f).toLocaleDateString('es-ES');
}

function fmtEuro(v) {
  return Number(v || 0).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' });
}

export default function PedidoSession({ sesion }) {
  const { cerrarSesion } = useSession();
  const [pedido, setPedido] = useState(null);
  const [editando, setEditando] = useState(false);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState(null);

  const cargar = useCallback(async () => {
    setCargando(true);
    setError(null);
    try {
      const { data } = await api.get(`/pedidos/${sesion.entityId}`);
      setPedido(data);
    } catch {
      setError('No se pudo cargar el pedido.');
    } finally {
      setCargando(false);
    }
  }, [sesion.entityId]);

  useEffect(() => { setEditando(false); cargar(); }, [cargar]);

  if (cargando) return <div className="session-content"><p className="empty">Cargando…</p></div>;
  if (error) return <div className="session-content"><div className="alert-error">{error}</div></div>;
  if (!pedido) return null;

  const lineas = pedido.lineas || [];

  return (
    <div className="session-content">
      <div className="session-actions" style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 16 }}>
        <PedidoAcciones pedido={pedido} onEditar={() => setEditando(true)} onActualizado={(accion) => accion !== 'eliminar' ? cargar() : undefined} onEliminado={() => cerrarSesion(sesion.id)} />
      </div>
      {editando && <Presupuestos pedidoInicial={pedido} onCerrarPedido={() => setEditando(false)} onPedidoGuardado={async () => { setEditando(false); await cargar(); }} />}
      <div className="session-panels" style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', marginBottom: 24, padding: 0 }}>
        <div className="session-panel">
          <div className="session-panel-title">Número</div>
          <div className="session-kpi">#{pedido.numero || '—'}</div>
        </div>
        <div className="session-panel">
          <div className="session-panel-title">Fecha</div>
          <div className="session-kpi" style={{ fontSize: 18 }}>{fmtFecha(pedido.fecha || pedido.createdAt)}</div>
        </div>
        <div className="session-panel">
          <div className="session-panel-title">Estado</div>
          <div className="session-kpi" style={{ fontSize: 18 }}>{pedido.estado || '—'}</div>
        </div>
        <div className="session-panel">
          <div className="session-panel-title">Total</div>
          <div className="session-kpi">{fmtEuro(pedido.total)}</div>
        </div>
      </div>

      {pedido.autogenerado && (
        <div className="alert-info" style={{ marginBottom: 16 }}>
          Este pedido se generó automáticamente al crear una factura directa.
        </div>
      )}

      {pedido.cliente && (
        <p style={{ marginBottom: 16, fontSize: 14, color: 'var(--text-soft)' }}>
          <strong>Cliente:</strong> {pedido.cliente?.nombre || pedido.cliente}
        </p>
      )}

      {lineas.length > 0 && (
        <div className="table-wrap" style={{ marginTop: 8 }}>
          <table className="data-table">
            <thead>
              <tr><th>Descripción</th><th>Cant.</th><th>Precio unit.</th><th>Total</th></tr>
            </thead>
            <tbody>
              {lineas.map((l, i) => (
                <tr key={i}>
                  <td>{l.descripcion || '—'}</td>
                  <td>{l.cantidad ?? '—'}</td>
                  <td>{fmtEuro(l.precioUnitario)}</td>
                  <td>{fmtEuro(l.total ?? (l.cantidad * l.precioUnitario))}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '12px 16px', fontSize: 15, gap: 24 }}>
            <span>Total: <strong>{fmtEuro(pedido.total)}</strong></span>
          </div>
        </div>
      )}
    </div>
  );
}
